import type { BalanceDataInterface } from '@/interfaces/balanceSheet';

export const withoutZeroCategories = (
  balanceData: BalanceDataInterface,
): BalanceDataInterface => ({
  ...balanceData,
  assets: {
    ...balanceData.assets,
    categories: balanceData.assets.categories.filter((c) => c.total !== 0),
  },
  liabilities: {
    ...balanceData.liabilities,
    categories: balanceData.liabilities.categories.filter((c) => c.total !== 0),
  },
});
